<template>
  <div>
    <Divider content-position="left">考试配置</Divider>
    <Field
      label="目标时间"
      :model-value="ExamTimeToMin"
      label-width="4.4em"
      readonly
    />
    <Field
      label="目标分数"
      :model-value="orderData.targetScore + '分'"
      label-width="4.4em"
      readonly
    />
    <Field
      label="完成时间"
      :model-value="orderData.targetDate"
      label-width="4.4em"
      readonly
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Field, Divider } from "vant";
import { useOrder } from "@/composables/useOrder";
const { orderData } = useOrder();
// 格式化时间
const ExamTimeToMin = computed({
  get() {
    const minute = Math.floor(orderData.value.targetExamTime / 60);
    const second = orderData.value.targetExamTime % 60;
    return `${minute}分${second}秒`;
  },
});
</script>
